import { Component, OnInit } from '@angular/core';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { Router, RoutesRecognized, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-employee-navtab',
  templateUrl: './employee-navtab.component.html',
  styleUrls: ['./employee-navtab.component.css']
})
export class EmployeeNavtabComponent implements OnInit {
  public agentName: any;
  public agentId: any;
  public docId: any;
  public employeeDetails: any;
  public role: string;
  hideFlag: boolean = false;
  empID: any;
  activeTab;
  agentID: any;
  navTabs = ['Employee Summary', 'Documents'];
  clientEmpNavTabs = ['Employee Summary', 'Requirements'];
  constructor(private router: Router, private agentEmployeeService: AgentEmployeeService, public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
    if (this.role == 'PC Client') {
      this.hideFlag = true;
    }
    this.agentName = localStorage.getItem("AgentName");
    this.docId = localStorage.getItem("dbId");
    this.empID = localStorage.getItem("EmployeeId");
    this.agentID = localStorage.getItem("AgentId");
    this.getSelectedEmployeeDetails();
    if (this.docId == undefined || null) {
      this.getByEmployeeID();
    } else {
      this.getSelectedEmployeeDetails();
    }
    if (this.activatedRoute.snapshot.params["docType"] !== undefined && this.activatedRoute.snapshot.params["docType"] !== '') {
      if (this.activatedRoute.snapshot.params["docType"] === 'EmployeeSummary')
        this.activeTab = 'Employee Summary';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Requirements' && this.role == 'PC Client')
        this.activeTab = 'Requirements';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Documents' && this.role !== 'PC Client')
        this.activeTab = 'Documents';
    }
  }

  selectedTab(tab) {
    if (tab === 'Employee Summary') {
      this.activeTab = 'Employee Summary';
      this.router.navigate(['agent/agentemployee', localStorage.getItem('AgentId'), 'EmployeeSummary', this.empID]);
    }
    else if (tab === 'Documents' && this.role !== 'PC Client') {
      this.activeTab = 'Documents';
      this.router.navigate(['agent/agentemployee', localStorage.getItem('AgentId'), 'Documents', this.empID]);
    }
    else if (tab === 'Requirements' && this.role == 'PC Client') {
      this.activeTab = 'Requirements';
      this.router.navigate(['agent/agentemployee', localStorage.getItem('AgentId'), 'Requirements', this.empID]);
    }
  }

  getByEmployeeID() {
    this.agentEmployeeService.getByAgentEmployeeID(this.empID).subscribe(res => {
      this.employeeDetails = res[0];
    });
  }
  getSelectedEmployeeDetails() {
    this.agentEmployeeService.getagentemployeeby_id(this.docId, this.agentID).subscribe(res => {
      this.employeeDetails = res.Vendors[0];
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/employee-navtab/employee-navtab.component.ts